import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MyErrorStateMatcher } from '../../../utilities/edit-threat.error-matcher';
import { EditThreatUtilities, editThreatFormNames } from '../../../utilities';
import { EditThreatFormNameModel } from '../../../../../shared';

@Component({
  moduleId: module.id,
  selector: 'app-tlm-edit-threat-gracie-number',
  templateUrl: './gracie-number.component.html'
})
export class EditThreatGracieNumberComponent {
  @Input() gracieNumberFormGroup: UntypedFormGroup;
  @Input() index: number;
  @Input() length: number;
  @Input() isLast: boolean;
  @Input() removeItem: (n: number) => void;
  @Input() isPopulated: () => boolean;
  @Input() matAppearance: string;
  @Input() errorMatcher: MyErrorStateMatcher;
  formNames: EditThreatFormNameModel;

  constructor(private editThreatUtils: EditThreatUtilities) {
    this.formNames = editThreatFormNames;
  }

  removeActionEnabled(): boolean {
    return this.editThreatUtils.removeActionEnabled(this.length, this.isPopulated, this.gracieNumberFormGroup);
  }

  removeOnClick(index: number) {
    if (this.removeActionEnabled()) {
      this.removeItem(index);
    }
  }
}
